const useStyles = (theme, expanded, index) => ({
  acordion: {
    padding: "0px 5px",
    borderRadius: "5px",
    backgroundColor: theme.palette.background.paperSelectedMaps,
    boxShadow: "0px 0px 5px  #0000001a",
    border: "none",
    "&::before": {
      display: "none",
    },
    "&:hover": {
      backgroundColor:
        expanded == index ? "none" : theme.palette.background.hover,
    },
  },
  stackOption: {
    flexDirection: "row",
    width: "100%",
    p: "5px",
    alignItems: "center",
  },
  textoLimitado: {
    display: "-webkit-box",
    WebkitLineClamp: 2, // Limita o texto a 2 linhas
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  line: {
    position: "absolute",
    backgroundColor: "primary.main",
    height: "100%", //typeElement == "Host" ? "150px" : "230px",
    minWidth: "3px",
  },
  text: {
    fontSize: "14px",
  },
  title: {
    fontSize: "14px",
    fontWeight: 500,
    color: theme.palette.text.shadow,
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.background.paperLinkedMaps,
      boxShadow: "none",
      width: "100%",
      "&:hover": {
        backgroundColor: theme.palette.background.paperLinkedMaps,
      },
    },
  },
});
export default useStyles;
